import Vue from 'vue'
import Router from 'vue-router'
// import Landing from './views/Landing.vue'

import User from "./views/User/User";
import UserList from "./views/User/UserList";
import UserAdd from "./views/User/UserAdd";
import UserEdit from "./views/User/UserEdit";

import Feature from "./views/Feature/Feature";
import FeatureList from "./views/Feature/FeatureList";
import FeatureAdd from "./views/Feature/FeatureAdd";
import FeatureEdit from "./views/Feature/FeatureEdit";

import Company from "./views/Company/Company";
import CompanyList from "./views/Company/CompanyList";
import CompanyAdd from "./views/Company/CompanyAdd";
import CompanyEdit from "./views/Company/CompanyEdit";

import Guest from "./views/Guest/Guest";
import GuestList from "./views/Guest/GuestList";
import GuestEdit from "./views/Guest/GuestEdit";
import GuestBatchAdd from "./views/Guest/GuestBatchAdd";

import Event from "./views/Event/Event";
import EventList from "./views/Event/EventList";
import EventAdd from "./views/Event/EventAdd";
import EventDetail from "./views/Event/EventDetail";
import EventEdit from "./views/Event/EventEdit";
import EventCmsTab from "./views/Event/EventCmsTab";
import EventFeatureList from "./views/Event/EventFeatureList";
import EventLayout from "./views/Event/EventLayout";
import EventColor from "./views/Event/EventColor";
import EventHome from "./views/Event/EventHome";
import EventAbout from "./views/Event/EventAbout";
import EventAgenda from "./views/Event/EventAgenda";
import EventNewsList from "./views/Event/EventNewsList";
import EventFaq from "./views/Event/EventFaq";
import EventGeneral from "./views/Event/EventGeneral";
import EventRoom from "./views/Event/EventRoom";
import EventPromoCode from "./views/Event/EventPromoCode";
import EventIFrame from "./views/Event/EventIFrame";
import EventDocument from "./views/Event/EventDocument";
import EventIcon from "./views/Event/EventIcon";
import EventSpeaker from "./views/Event/EventSpeaker";
import EventGalleryList from "./views/Event/EventGalleryList";
import EventSponsorList from "./views/Event/EventSponsorList";
import EventNotificationList from "./views/Event/EventNotificationList";
import EventNotificationGroupList from "./views/Event/EventNotificationGroupList";
import EventReport from "./views/Event/EventReport";
import EventReportGuest from "./views/Event/EventReportGuest";
import EventReportAgendaGroup from "./views/Event/EventReportAgendaGroup";
import EventReportGeneral from "./views/Event/EventReportGeneral.vue";
import EventReportBusinessMatching from "./views/Event/EventReportBusinessMatching.vue";
import EventReportAppAction from "./views/Event/EventReportAppAction.vue";
import EventGuestList from "./views/Event/EventGuestList";
import EventGuestEdit from "./views/Event/EventGuestEdit";
import EventProfile from "./views/Event/EventProfile";
import MobileApp from "./views/MobileApp/MobileApp";
import MobileAppList from "./views/MobileApp/MobileAppList";
import MobileAppAdd from "./views/MobileApp/MobileAppAdd";
import MobileAppEdit from "./views/MobileApp/MobileAppEdit";
import EventMerchantList from "./views/Event/EventMerchantList.vue";
import EventMerchantEdit from "./views/Event/EventMerchantEdit.vue";
import EventMerchantBatchAdd from "./views/Event/EventMerchantBatchAdd.vue";
import EventReportMerchant from "./views/Event/EventReportMerchant.vue";
import EventEvoucherGuestsList from "./views/Event/EventEvoucherGuestsList.vue";
import EventEvoucherGuestsEdit from "./views/Event/EventEvoucherGuestsEdit.vue";
import EventEvoucherGuestsBatchAdd from "./views/Event/EventEvoucherGuestsBatchAdd.vue";
import EventReportEvoucherGuests from "./views/Event/EventReportEvoucherGuests.vue";
import EventTransport from "./views/Event/EventTransport.vue";
import EventFlight from "./views/Event/EventFlight.vue";
import EventRestaurant from "./views/Event/EventRestaurant.vue";
import EventUsefulInformation from "./views/Event/EventUsefulInformation.vue";
import EventSingleNotification from "./views/Event/EventSingleNotification.vue";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'landing',
            redirect: { name: 'event-list' },
        },
        {
            path: '/user',
            component: User,
            children: [
                {
                    path: '',
                    name: 'user-list',
                    component: UserList,
                },
                {
                    path: 'add',
                    name: 'user-add',
                    component: UserAdd,
                },
                {
                    path: ':userId',
                    name: 'user-edit',
                    component: UserEdit,
                },
            ],
        },
        {
            path: '/feature',
            component: Feature,
            children: [
                {
                    path: '',
                    name: 'feature-list',
                    component: FeatureList,
                },
                {
                    path: 'add',
                    name: 'feature-add',
                    component: FeatureAdd,
                },
                {
                    path: ':featureId',
                    name: 'feature-edit',
                    component: FeatureEdit,
                },
            ],
        },
        {
            path: '/company',
            component: Company,
            children: [
                {
                    path: '',
                    name: 'company-list',
                    component: CompanyList,
                },
                {
                    path: 'add',
                    name: 'company-add',
                    component: CompanyAdd,
                },
                {
                    path: ':companyId',
                    name: 'company-edit',
                    component: CompanyEdit,
                },
            ],
        },
        {
            path: '/guest',
            component: Guest,
            children: [
                {
                    path: '',
                    name: 'guest-list',
                    component: GuestList,
                },
                {
                    path: ':guestId',
                    name: 'guest-edit',
                    component: GuestEdit,
                },
                /*
                {
                    path: 'add',
                    name: 'guest-add',
                    component: GuestAdd,
                },
                {
                    path: 'detail/:guestId',
                    name: 'guest-detail',
                    component: GuestDetail,
                },
                */
            ],
        },
        {
            path: '/event',
            component: Event,
            children: [
                {
                    path: '',
                    name: 'event-list',
                    component: EventList,
                },
                {
                    path: 'add',
                    name: 'event-add',
                    component: EventAdd,
                },
                {
                    path: ':eventId',
                    component: EventEdit,
                    props: true,
                    children: [
                        /*
                        {
                            path: '',
                            name: 'event-edit',
                            component: EventDetail,
                        },
                        */
                        {
                            path: 'details',
                            name: 'event-details',
                            component: EventDetail,
                        },
                        {
                            path: 'cms-tabs',
                            name: 'event-cms-tabs',
                            component: EventCmsTab,
                        },
                        {
                            path: 'features',
                            name: 'event-features',
                            component: EventFeatureList,
                        },
                        {
                            path: 'layouts',
                            name: 'event-layouts',
                            component: EventLayout,
                        },
                        {
                            path: 'colors',
                            name: 'event-colors',
                            component: EventColor,
                        },
                        {
                            path: 'home',
                            name: 'event-home',
                            component: EventHome,
                        },
                        {
                            path: 'about',
                            name: 'event-about',
                            component: EventAbout,
                        },
                        {
                            path: 'agenda',
                            name: 'event-agenda',
                            component: EventAgenda,
                        },
                        {
                            path: 'news',
                            name: 'event-news',
                            component: EventNewsList,
                        },
                        {
                            path: 'speaker',
                            name: 'event-speaker',
                            component: EventSpeaker,
                        },
                        {
                            path: 'galleries',
                            name: 'event-galleries',
                            component: EventGalleryList,
                        },
                        {
                            path: 'sponsor',
                            name: 'event-sponsor',
                            component: EventSponsorList,
                        },
                        {
                            path: 'notifications',
                            name: 'event-notifications',
                            component: EventNotificationList,
                        },
                        {
                            path: 'single-notification',
                            name: 'event-single-notification',
                            component: EventSingleNotification,
                        },
                        {
                            path: 'guest/add',
                            name: 'guest-batch-add',
                            component: GuestBatchAdd,
                        },
                        {
                            path: 'guest/add',
                            name: 'guest-batch-add',
                            component: GuestBatchAdd,
                            children: [
                                {
                                    path: 'template',
                                    name: 'guest-template',
                                    component: EventReportGuest,
                                },
                            ]
                        },
                        {
                            path: 'guest',
                            name: 'event-guests',
                            component: EventGuestList,
                            children: [
                                {
                                    path: ':guestId',
                                    name: 'event-guests-edit',
                                    component: EventGuestEdit,
                                },
                            ]
                        },
                        {
                            path: 'merchant/add',
                            name: 'merchant-batch-add',
                            component: EventMerchantBatchAdd,
                        },
                        {
                            path: 'merchant/add',
                            name: 'merchant-batch-add',
                            component: EventMerchantBatchAdd,
                            children: [
                                {
                                    path: 'template',
                                    name: 'merchant-template',
                                    component: EventReportMerchant,
                                },
                            ]
                        },
                        {
                            path: 'merchant',
                            name: 'event-merchants',
                            component: EventMerchantList,
                            children: [
                                {
                                    path: ':merchantId',
                                    name: 'event-merchants-edit',
                                    component: EventMerchantEdit,
                                },
                            ]
                        },
                        {
                            path: 'evoucher/add',
                            name: 'evoucher-guests-batch-add',
                            component: EventEvoucherGuestsBatchAdd,
                        },
                        {
                            path: 'evoucher/add',
                            name: 'evoucher-guests-batch-add',
                            component: EventEvoucherGuestsBatchAdd,
                            children: [
                                {
                                    path: 'template',
                                    name: 'evoucher-guests-template',
                                    component: EventReportEvoucherGuests,
                                },
                            ]
                        },
                        {
                            path: 'evoucher',
                            name: 'evoucher-guests',
                            component: EventEvoucherGuestsList,
                            children: [
                                {
                                    path: ':evoucherGuestsId',
                                    name: 'evoucher-guests-edit',
                                    component: EventEvoucherGuestsEdit,
                                },
                            ]
                        },
                        {
                            path: 'profile',
                            name: 'event-profile',
                            component: EventProfile,
                        },
                        {
                            path: 'notification-groups',
                            name: 'event-notification-groups',
                            component: EventNotificationGroupList,
                        },
                        {
                            path: 'report',
                            name: 'event-report',
                            component: EventReport,
                            children: [
                                {
                                    path: 'guest',
                                    name: 'event-report-guest',
                                    component: EventReportGuest,
                                },
                                {
                                    path: 'agenda-group',
                                    name: 'event-report-agenda-group',
                                    component: EventReportAgendaGroup,
                                },
                                {
                                    path: 'general',
                                    name: 'event-report-general',
                                    component: EventReportGeneral,
                                },
                                {
                                    path: 'business-matching',
                                    name: 'event-report-business-matching',
                                    component: EventReportBusinessMatching,
                                },
                                {
                                    path: 'app-action',
                                    name: 'event-report-app-action',
                                    component: EventReportAppAction,
                                },
                            ]
                        },
                        {
                            path: 'faq',
                            name: 'event-faq',
                            component: EventFaq,
                        },
                        {
                            path: 'general',
                            name: 'event-general',
                            component: EventGeneral,
                        },
                        {
                            path: 'room',
                            name: 'event-room',
                            component: EventRoom,
                        },
                        {
                            path: 'promo-code',
                            name: 'event-promo-code',
                            component: EventPromoCode,
                        },
                        {
                            path: 'iframe',
                            name: 'event-iframe',
                            component: EventIFrame,
                        },
                        {
                            path: 'document',
                            name: 'event-document',
                            component: EventDocument,
                        },
                        {
                            path: 'icon',
                            name: 'event-icon',
                            component: EventIcon,
                        },
                        {
                            path: 'useful-information',
                            name: 'event-useful-information',
                            component: EventUsefulInformation,
                        },
                        {
                            path: 'transport',
                            name: 'event-transport',
                            component: EventTransport,
                        },
                        {
                            path: 'flight',
                            name: 'event-flight',
                            component: EventFlight,
                        },
                        {
                            path: 'restaurant',
                            name: 'event-restaurant',
                            component: EventRestaurant,
                        },
                    ],
                },
            ],
        },
        {
            path: '/mobile-app',
            component: MobileApp,
            children: [
                {
                    path: '',
                    name: 'mobile-app-list',
                    component: MobileAppList,
                },
                {
                    path: 'add',
                    name: 'mobile-app-add',
                    component: MobileAppAdd,
                },
                {
                    path: ':mobileAppId',
                    name: 'mobile-app-edit',
                    component: MobileAppEdit,
                },
            ],
        },
    ]
})
